import { pickT } from "@repo/shared";
import { getFlowComponentLabel } from "@/components/flow/flow-component-types";
import type { ComponentType, PageType } from "@/lib/types/flow";
import { T } from "./misplaced-component-notice.i18n";

type MisplacedComponentNoticeProps = {
  componentType: ComponentType;
  pageType: PageType;
  /** Also names the component (`getFlowComponentLabel`), so it stays explicit. */
  language: string;
};

// Generic, single-node notice for a component placed on a page type it is not
// allowed on (e.g. a goal-only component on a global page). Replaces the old
// per-component defensive cases. Inline en_GB + nb_NO only, matching the
// previous asset_allocation placeholder; advisor-only (the public flow renders
// nothing for misplaced components).
export function MisplacedComponentNotice({
  componentType,
  pageType,
  language,
}: MisplacedComponentNoticeProps) {
  const t = pickT(T, language);
  const name = getFlowComponentLabel(componentType, language);
  const pageLabel = pageType === "goal" ? t.goalPages : t.globalPages;

  return (
    <div className="text-sm text-muted-foreground border border-dashed rounded-lg p-4">
      {t.message(name, pageLabel)}
    </div>
  );
}
